import { useLocation } from "react-router-dom";

import { MenuItem } from "../components/navbar";
import { useMenu } from "./menu";

export function useSubMenu(): MenuItem[] {
  const location = useLocation();

  const slug1 = location.pathname.split("/")[1] || null;
  const menu = useMenu();

  const menuItem = menu.find(
    (item) => "slug" in item && item.slug === `/${slug1}`,
  );

  if (menuItem && "children" in menuItem && menuItem.children) {
    return menuItem.children;
  }

  return [];
}
